import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import {
  Paper,
  PaperContent,
  PaperHeadline,
  Option,
  Text,
  Button
} from '../..'

export class PetplaceMakePaymentCard extends React.PureComponent {
  static propTypes = {
    caption: PropTypes.string,

    errorMessage: PropTypes.string,
    existingCardOptions: PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool,
        onClick: PropTypes.func,
        description: PropTypes.string
      })
    ),
    payWithDifferentCardOption: PropTypes.shape({
      active: PropTypes.bool,
      hidden: PropTypes.bool,
      onClick: PropTypes.func
    }),

    continueButtonProp: PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      onClick: PropTypes.func
    }),
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    caption: 'Do you want to make a payment with your saved card?',
    existingCardOptions: [],
    payWithExistingCardOption: {},
    payWithDifferentCardOption: {}
  }

  render() {
    const {
      caption,
      errorMessage,
      existingCardOptions,
      payWithDifferentCardOption,
      continueButtonProp,
      id,
      className,
      style,
      refProp
    } = this.props

    const isNoSavedCards = ( existingCardOptions.length === 0) ? 'ui-petplace-make-a-payment-card__caption' : '';

    return (
      <Paper
        id={id}
        className={cn('ui-petplace-make-a-payment-card', className)}
        style={style}
        ref={refProp}
      >
        {/* <PaperHeadline>Make a Payment</PaperHeadline> */}

        <PaperContent className='ui-petplace-make-a-payment-card__content'>
          <Text type={Text.Types.bodyBold}>Make a Payment</Text>
          <Text 
            type={Text.Types.caption}
            className={cn(isNoSavedCards)}
          >
            {caption}
          </Text>

          {errorMessage && (
            <Text
              type={Text.Types.bodyBold}
              className='ui-petplace-make-a-payment-card__error-message'
            >
              {errorMessage}
            </Text>
          )}

          <div className='ui-petplace-make-a-payment-card__options'>
            {existingCardOptions.map(({ description, ...rest }) => (
              <Option
                key={`payment-option-${description}`}
                label={
                  <>
                    <span className='ui-petplace-make-a-payment-card__option__label--desktop'>
                      Pay with saved card
                    </span>
                  </>
                }
                description={<Text>{description}</Text>}
                {...rest}
              />
            ))}

            {!payWithDifferentCardOption.hidden && (
              <Option
                label='Pay with a different card'
                {...payWithDifferentCardOption}
              />
            )}
          </div>

          <Button
            className='ui-petplace-make-a-payment-card__action'
            color={Button.Colors.tertiary}
            {...continueButtonProp}
          >
            {continueButtonProp.label}
          </Button>
        </PaperContent>
      </Paper>
    )
  }
}
